import Vue from 'vue';
import passport from './passport';
import profile from './profile';
import { getDefaultTimeZone } from '@/locales/timeZone';
import { SystemMode } from '@/types/base';

import { getField, updateField } from '@/libs/vuexHelper';
import { getUserConfig, onlineStatus, onlineSwitch, getSameTeamList } from '@/api/sys/project/userList';
import { getSecret } from '@/api/sys/user/promote';
import { localSave, localRead } from '@/libs/util';
import { PROMPT_SOUNDS } from '@/constants/common';

const systemMode: SystemMode = 'TOKEN_MODE';
const systemMap: any = {
    TOKEN_MODE: 'tokenMode',
    AUTHORIZE_MODE: 'authMode',
};

const initSameTeamList = (projectId: string, userId: string): string[] => {
    const result = localRead(`SS_SAMS_MEMBERS_${projectId}_${userId}`) ? JSON.parse(localRead(`SS_SAMS_MEMBERS_${projectId}_${userId}`)) : [];
    return result;
};

export default {
    namespaced: true,
    state: {
        nickname: '',
        userName: '',
        userId: '',
        loginToken: '',
        email: '',
        phone: '',
        career: '',
        industry: '',
        projectCode: '',
        projectCreatedTime: '',
        project: '',
        projectId: '',
        agentId: '',
        roleId: '', // 0-超级管理员 1-管理员 2-成员 3-特殊成员
        isAllMonthBalance: '0', // 用户是否产生过1个月以上的月付套餐（1是0否）
        payManagerId: '0', // 用户是否关联了售前客户经理（0 无）
        customerSuccessId: '0', // 用户是否关联了客户成功经理（0 无）
        identityId: '',
        superRole: '',
        avatarImgPath: '',
        access: '',
        token: '',
        accountNum: '', // '0'是无限浏览器
        isBalanceTips: '',
        inviteCode: '', // 邀请码
        isActive: '0', // 账号是否激活： 0 未激活 1 已激活
        activityStatus: '0', // 12.12 活动是否已过
        isShowEye: true,
        isChooseBatchBatch: false,
        batchIdNum: '',
        batchName: '',
        fee: '',
        userNum: '',
        createdTime: '',
        getAdsVersion: '',
        getPackage: '',
        showCountDown: false,
        showCountDownTime: '',
        language: '',
        translate_language: '',
        timeZone: getDefaultTimeZone(),
        isAllBatch: '0', // '0' 没有全部批次，'1' 有全部批次
        extraUserNum: 0, // 额外用户数
        packageType: '', // 套餐类型
        package_type: '', // 价格版本
        isAllUser: '0', // 是否有全部账号（1 是，0 否）
        authorizationType: 'batch_authorization', // 授权方式（account_authorization 账号授权，batch_authorization 批次授权）；账号授权情况下，所有用户导入都可以选择未分组
        isExpired: '0', // (0 未过期，1已过期)
        isNewUi: '0', // 0就是没有弹过窗的，1就是旧版，2就是新版, 3也是新版(第一次切换到新版)
        accountColumn: [],
        taskColumn: [],
        balanceDay: '',
        systemMode,
        systemModeList: ['TOKEN_MODE'],
        systemMap,
        mainMode: '', // 给前端代码使用，主要用于 getMenuByRouter， store/sys/main
        tokenStatus: true, // token导入是否正常，false为达到上限
        authStatus: true, // 授权是否正常，false为达到上限
        isOwner: '0', //  0 切换了其它无权限的项目，1 切换的是有权限的项目
        online_status: '0', // 0-离线 1-在线 2-忙碌
        can_select_status: ['0', '1', '2'], // 当前可以设置的状态
        channel_auth_type: '', // 渠道权限
        online_time_switch: '0',
        temporary_email: '0', // 0-非临时邮箱 1-临时邮箱
        register_invite_code: '', // 邀请码
        temporary_project: '0', // '0' | '1' 是否首次注册项目，'1' 是， '0' 否
        wxOpenid: '',
        is_open_two_verify: '', // 是否开启登录二次验证, '1' 已开启， 0 未开启
        password_empty: '', // 是否未设置密码, '1' 是， 0 否
        is_session_list_labels: '0', // '0' | '1' 是否显示访客标签
        is_session_list_remark_name: '0', // '0' | '1' 是否优先显示备注名
        is_session_list_last_reply_time: '0', // '0' | '1' 是否显示最后回复时间
        is_session_list_channel_name: '0', // '0' | '1' 会话列表是否显示渠道账号名
        user_type: 'advanced', // ordinary 普通， advanced 高级
        balance: 0, // 钱包余额
        source: '',
        information_hidden: '0',
        other_information_hidden: ['1', '2', '3', '4', '5'], // 其他用户信息是否隐藏，1-广告信息隐藏 2-Tg用户名隐藏 3-fb主页信息藏 4-手机号隐藏 5-邮箱隐藏
        google_email: '',
        certificationNotice: '', // 是否提示需要kyc验证（1 提示， 0不提示）
        certificationInfo: '', // kyc验证信息（空字符串表示未认证）
        is_session_list_nickname: '0', // '0' | '1' 是否显示当前接待客服
        is_system_notice: '0',
        new_socket: '0', // '0' | '1' 是否使用新的socket
        telegram_id: '', // 绑定的tg
        facebook_id: '', // 绑定的fb
        whatsapp_phone: '', // 绑定的whatsapp
        sameTeamList: [], // 当前账号同组成员
        created_time: '', // 当前账号创建时间
        is_session_list_last_phone: '0', // '0' | '1' 是否显示手机号
        is_session_list_last_email: '0', // '0' | '1' 是否显示邮箱
        sound_notice: '1', // 提示音ID
        sound_notice_interval: 10, // 提示音间隔时间（s）
        isInputAreaDisabledLimit: '0', // 是否WhatsApp/WhatsAppAPI地区限制 & 插件ip限制 0-无限制 1-被限制（后端在原有WhatsApp 字段上增加插件限制逻辑）

        openCustomerSuccessWindow: false, // 是否打开客户成功专属链接窗口
        limitPurchaseBm: false, // 是否限制购买bm套餐
    },
    getters: {
        getField,
        sysUserId(state: any) {
            return state.userId;
        },
        createdTime(state: any) {
            return state.created_time || '';
        },
        sysUserName(state: any) {
            return state.nickname;
        },
        sysUserAvatar(state: any) {
            return state.avatarImgPath;
        },
        sysRoleId(state: any) {
            return state.roleId;
        },
        isExpired(state: any) {
            return state.isExpired;
        },
        isPackageV1(state: any) {
            return state.package_type === 'PACKAGE_V1';
        },
        isPackageV2(state: any) {
            return state.package_type === 'PACKAGE_V2';
        },
        isPackageV3(state: any) {
            return state.package_type === 'PACKAGE_V3';
        },
        isPackageV4(state: any) {
            return state.package_type === 'PACKAGE_V4';
        },
        isPackageV5(state: any) {
            return state.package_type === 'PACKAGE_V5';
        },
        // 套餐版本
        packageText(state: any) {
            return state.packageType;
        },
        // 价格版本
        packageType(state: any) {
            return state.package_type;
        },
        // 套餐截止日期(时间戳-秒级)
        balanceDay(state: any) {
            return state.balanceDay;
        },
        balance(state: any) {
            // return +state.balance.toFixed('4');
            return state.balance;
        },
        informationHidden(state: any) {
            return state.information_hidden === '1';
        },
        otherInformationHidden(state: any) {
            return state.other_information_hidden;
        },
        useSocketV2(state: any) {
            return state.new_socket === '1';
        },
        isHiddenPhone(state: any) {
            return state.information_hidden === '1' && state.other_information_hidden.includes('4');
        },
        isHiddenEmail(state: any) {
            return state.information_hidden === '1' && state.other_information_hidden.includes('5');
        },
    },
    mutations: {
        updateField,
        setPasswordEmpty(state: any, password_empty: string) {
            state.password_empty = password_empty;
        },
        setExtraUserNum(state: any, extraUserNum: string) {
            const that = state;
            that.extraUserNum = Number(extraUserNum);
        },
        setIsExpired(state: any, isExpired: string) {
            const that = state;
            that.isExpired = isExpired;
        },
        setIsNewUi(state: any, isNewUi: string) {
            const that = state;
            that.isNewUi = isNewUi;
        },
        setPackageType(state: any, packageType: string) {
            const that = state;
            that.packageType = packageType;
        },
        setPackageType2(state: any, packageType: string) {
            state.package_type = packageType;
        },
        setActivityStatus(state: any, status: string) {
            const that = state;
            that.activityStatus = status;
        },
        setIsAllBatch(state: any, status: string) {
            const that = state;
            that.isAllBatch = status;
        },
        setAuthorizationType(state: any, status: string) {
            const that = state;
            that.authorizationType = status;
        },
        setIsAllUser(state: any, status: string) {
            const that = state;
            that.isAllUser = status;
        },
        setAccountColumn(state: any, list: []) {
            const that = state;
            that.accountColumn = list;
        },
        setProjectStatus(state: any, status: string) {
            const that = state;
            that.projectStatus = status;
        },
        setShowCountDownTime(state: any, CountDownTime: boolean) {
            const that = state;
            that.showCountDownTime = CountDownTime;
        },
        setShowCountDown(state: any, CountDown: boolean) {
            const that = state;
            that.showCountDown = CountDown;
        },
        setPackage(state: any, Package: string) {
            const that = state;
            that.getPackage = Package;
        },
        setAccountNum(state: any, value: string) {
            const that = state;
            that.accountNum = value;
        },
        setVersion(state: any, version: string) {
            const that = state;
            that.getAdsVersion = version;
        },
        setFee(state: any, fee: string) {
            const that = state;
            that.fee = fee;
        },
        setBatchName(state: any, getbatchName: string) {
            const that = state;
            that.batchName = decodeURIComponent(getbatchName);
        },
        setBatchIdNum(state: any, getbatchIdNum: string) {
            const that = state;
            that.batchIdNum = getbatchIdNum;
        },
        setBatch(state: any, chooseBatch: boolean) {
            const that = state;
            that.isChooseBatchBatch = chooseBatch;
        },
        setUserNum(state: any, num: string) {
            const that = state;
            that.userNum = num;
        },
        setAvatar(state: any, avatarPath: string) {
            const that = state;
            that.avatarImgPath = avatarPath;
        },
        setUserId(state: any, id: number) {
            const that = state;
            that.userId = id;
        },
        setUserName(state: any, name: string) {
            const that = state;
            that.userName = name;
        },
        setNickname(state: any, name: string) {
            const that = state;
            that.nickname = name;
        },
        setLoginToken(state: any, token: string) {
            const that = state;
            that.loginToken = token;
        },
        setEmail(state: any, email: string) {
            const that = state;
            that.email = email;
        },
        setPhone(state: any, phone: string) {
            const that = state;
            that.phone = phone;
        },
        setCareer(state: any, career: string) {
            const that = state;
            that.career = career;
        },
        setIndustry(state: any, industry: string) {
            const that = state;
            that.industry = industry;
        },
        setProject(state: any, project: string) {
            const that = state;
            that.project = project;
        },
        setProjectId(state: any, id: string) {
            const that = state;
            that.projectId = id;
            Vue.prototype.$SSProjectId = id;
        },
        setProjectCode(state: any, code: string) {
            const that = state;
            that.projectCode = code;
        },
        setProjectCreatedTime(state: any, value: string) {
            state.projectCreatedTime = value;
        },
        setAgentId(state: any, id: string) {
            state.agentId = id;
        },
        setIsInputAreaDisabledLimit(state: any, val: string) {
            state.isInputAreaDisabledLimit = val;
        },
        setIsOwner(state: any, status: string) {
            const that = state;
            that.isOwner = status;
        },
        setRoleId(state: any, id: string) {
            const that = state;
            that.roleId = id;
        },
        setIsAllMonthBalance(state: any, id: string) {
            state.isAllMonthBalance = id;
        },
        setPayManagerId(state: any, id: string) {
            state.payManagerId = id;
        },
        setCustomerSuccessId(state: any, id: string) {
            state.customerSuccessId = id;
        },
        setManagerId(state: any, id: string) {
            state.managerId = id;
        },
        setIdentityId(state: any, id: string) {
            state.identityId = id;
        },
        setSuperRole(state: any, id: string) {
            const that = state;
            that.superRole = id;
        },
        setAccess(state: any, access: []) {
            const that = state;
            that.access = access;
        },
        setToken(state: any, token: string) {
            const that = state;
            that.token = token;
        },
        setIsBalanceTips(state: any, value: string) {
            const that = state;
            that.isBalanceTips = value;
        },
        setInviteCode(state: any, value: string) {
            const that = state;
            that.inviteCode = value;
        },
        setIsActive(state: any, value: string) {
            const that = state;
            that.isActive = value;
        },
        setIsShowEye(state: any, value: boolean) {
            const that = state;
            that.isShowEye = value;
        },
        setCreatedTime(state: any, value: boolean) {
            const that = state;
            that.createdTime = value;
        },
        setLanguage(state: any, value: string) {
            state.language = value;
        },
        setTranslateLanguage(state: any, value: string) {
            state.translate_language = value;
        },
        setTimeZone(state: any, value: string) {
            if (value) {
                state.timeZone = value;
            }
        },
        setBalanceDay(state: any, value: string) {
            if (value) {
                state.balanceDay = value;
            }
        },
        // 设置系统模式
        setSystemMode(state: any, name: string) {
            state.systemMode = name;
            state.mainMode = systemMap[name];
        },
        // 初始化系统模式
        initSystemMode(state: any, list: string[]) {
            list = list.length ? list : ['TOKEN_MODE'];
            state.systemModeList = list;
            state.systemMode = list[0];
            state.mainMode = systemMap[list[0]];
        },
        setModeStatus(state: any, option: { auth: boolean; token: boolean; }) {
            state.tokenStatus = option.token;
            state.authStatus = option.auth;
        },
        setOnlineStatus(state: any, online_status: '0' | '1' | '2') {
            state.online_status = online_status;
        },
        setCanSelectStatus(state: any, can_select_status: '0' | '1' | '2'[]) {
            if (Array.isArray(can_select_status)) {
                state.can_select_status = can_select_status;
            } else {
                state.can_select_status = ['0', '1', '2'];
            }
        },
        setChannelAuthType(state: any, channel_auth_type: string) {
            state.channel_auth_type = channel_auth_type;
        },
        setOnlineTimeSwitch(state: any, online_time_switch: string) {
            state.online_time_switch = online_time_switch;
        },
        setTemporaryEmail(state: any, temporary_email: string) {
            state.temporary_email = temporary_email;
        },
        setRegisterInviteCode(state: any, register_invite_code: string) {
            state.register_invite_code = register_invite_code;
        },
        setTemporaryProject(state: any, temporary_project: string) {
            state.temporary_project = temporary_project;
        },
        setWxOpenid(state: any, wx_openid: string) {
            state.wxOpenid = wx_openid;
        },
        setIsOpenTwoVerify(state: any, is_open_two_verify: string) {
            state.is_open_two_verify = is_open_two_verify;
        },
        setIsSessionListLabels(state: any, is_session_list_labels: string) {
            state.is_session_list_labels = is_session_list_labels;
        },
        setIsSessionListRemarkName(state: any, is_session_list_remark_name: string) {
            state.is_session_list_remark_name = is_session_list_remark_name;
        },
        setIsSessionListLastReplyTime(state: any, is_session_list_last_reply_time: string) {
            state.is_session_list_last_reply_time = is_session_list_last_reply_time;
        },
        setIsSessionListChannelName(state: any, is_session_list_channel_name: string) {
            state.is_session_list_channel_name = is_session_list_channel_name;
        },
        setIsSessionListNickname(state: any, is_session_list_nickname: string) {
            state.is_session_list_nickname = is_session_list_nickname;
        },
        setUserType(state: any, type: string) {
            const that = state;
            that.user_type = type;
        },
        setBalance(state: any, balance: string) {
            state.balance = balance;
            // state.balance = Number(balance);
        },
        setSource(state: any, source: string) {
            state.source = source;
        },
        setInformation(state: any, val: string) {
            state.information_hidden = val || '0';
        },
        setOtherInformation(state: any, val: string[]) {
            state.other_information_hidden = val || [];
        },
        setGoogleEmail(state:any, val:string) {
            state.google_email = val;
        },
        setCertificationNotice(state: any, val: string) {
            state.certificationNotice = val;
        },
        setCertificationInfo(state: any, val: string) {
            state.certificationInfo = val;
        },
        setIsSystemNotice(state: any, val: string) {
            state.is_system_notice = val;
        },
        setNewSocket(state: any, val: '0' | '1') {
            state.new_socket = val;
        },
        setTelegramId(state:any, val:string) {
            state.telegram_id = val;
        },
        setFacebookId(state:any, val:string) {
            state.facebook_id = val;
        },
        setWhatsappPhone(state:any, val:string) {
            state.whatsapp_phone = val;
        },
        setSameTeamList: (state: any, val: string[]) => {
            state.sameTeamList = val;
        },
        setAccountCreatedTime: (state: any, val: string) => {
            state.created_time = val;
        },
        setIsSessionListPhone(state: any, is_session_list_last_phone: string) {
            state.is_session_list_last_phone = is_session_list_last_phone;
        },
        setIsSessionListEmail(state: any, is_session_list_last_email: string) {
            state.is_session_list_last_email = is_session_list_last_email;
        },
        setSoundNotice(state: any, sound_notice: string) {
            state.sound_notice = sound_notice;
        },
        setSoundNoticeInterval(state: any, sound_notice_interval: string) {
            state.sound_notice_interval = sound_notice_interval;
        },
        setOpenCustomerSuccessWindow(state: any, open: boolean) {
            state.openCustomerSuccessWindow = open;
        },
        setLimitPurchaseBm(state: any, limit_purchase_bm: '0' | '1') {
            state.limitPurchaseBm = limit_purchase_bm === '1';
        },
    },
    actions: {
        onlineStatus({ commit }: any) {
            return onlineStatus();
        },
        changeOnlineStatus({ commit, state }: any, { online, sys_user_id = '', event_type = '1' }: { online: '0' | '1'; sys_user_id?: string; event_type?: '0' | '1' }) {
            // 请求 成功后更新 vuex online_status
            return onlineSwitch({
                online_status: online,
                sys_user_id,
                event_type,
            }).then((res) => {
                if (!sys_user_id || (sys_user_id && sys_user_id === state.userId)) {
                    commit('setOnlineStatus', online);
                }
            });
        },
        getSecret() {
            return getSecret();
        },
        // 获取个人会话设置
        async getUserConfig({ commit }: any) {
            try {
                const res: any = await getUserConfig({
                    type: 'session_list_labels,session_list_remark_name,session_list_last_reply_time,session_list_channel_name,session_list_nickname,session_list_email,session_list_phone',
                });
                const list = res.data.data.list;
                if (list) {
                    const session_list_labels = list.session_list_labels || '0';
                    const session_list_remark_name = list.session_list_remark_name || '0';
                    const session_list_last_reply_time = list.session_list_last_reply_time || '0';
                    const session_list_channel_name = list.session_list_channel_name || '0';
                    const session_list_nickname = list.session_list_nickname || '0';
                    const session_list_phone = list.session_list_phone || '0';
                    const session_list_email = list.session_list_email || '0';
                    commit('setIsSessionListLabels', session_list_labels);
                    commit('setIsSessionListRemarkName', session_list_remark_name);
                    commit('setIsSessionListLastReplyTime', session_list_last_reply_time);
                    commit('setIsSessionListChannelName', session_list_channel_name);
                    commit('setIsSessionListNickname', session_list_nickname);
                    commit('setIsSessionListPhone', session_list_phone);
                    commit('setIsSessionListEmail', session_list_email);
                }
            } catch (error) {
                console.log(error);
            }
        },
        getSameTeamList({ commit, state }: any) {
            const localSamaList = initSameTeamList(state.projectId, state.userId);
            if (Array.isArray(localSamaList)) {
                commit('setSameTeamList', localSamaList);
            }
            return new Promise((resolve, reject) => {
                getSameTeamList()
                    .then((res) => {
                        const { sys_user_id, project_id, same_members } = res.data.data;
                        if (Array.isArray(same_members)) {
                            commit('setSameTeamList', same_members);
                            localSave(`SS_SAMS_MEMBERS_${project_id}_${sys_user_id}`, JSON.stringify(same_members));
                        }
                        resolve(res);
                    }).catch((err) => {
                        reject(err);
                    });
            });
        },
        setNoticeConfig({ commit, state }: any, { sound_notice, sound_notice_interval }: { sound_notice: string, sound_notice_interval: number | string }) {
            commit('setSoundNotice', sound_notice || '1');
            commit('setSoundNoticeInterval', Number(sound_notice_interval || '10'));
            const $sound_notice = document.getElementById(
                'sound_notice',
            ) as HTMLAudioElement;
            if ($sound_notice) {
                const soundInfo = PROMPT_SOUNDS.find((item) => item.id === sound_notice) || PROMPT_SOUNDS[0];
                $sound_notice.src = soundInfo.src;
            }
        },
    },
    modules: {
        passport,
        profile,
    },
};
